<template>
  <v-card v-if="evento.direccion_envio" class="m-b-5 elevation-0" outlined>
    <v-card-subtitle>
      <b>{{ $t('Dirrección') }}</b>
    </v-card-subtitle>
    <v-card-text>
      {{ evento.direccion_envio }}
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
      name: "Direcciones",
      props: {
          evento:Object
      },
      data() {
          return {

          };
      }
  }
</script>